import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppConfigService } from "../../config/app-config.service";
import { HtmlUtilsService } from "../../html-utils/html-utils.service";
import { RichSearchList } from "../../search/search-list/rich-search-list";
import { ListService } from "./list.service";
import { QueryParams } from "./query-params.model";
import { FacetService } from "./facets/facet.service";
import { FiltersConfig } from "../../config/filters/filters-config.model";
import { BehaviorSubject } from "rxjs/internal/BehaviorSubject";

@Component({
  selector: "app-list",
  templateUrl: "./list.component.html",
  styleUrls: ["./list.component.scss"],
})
export class ListComponent implements OnInit {
  @Output() searchEvent: EventEmitter<QueryParams>;

  @Input() omitTitle = false;

  _searchResult: RichSearchList;

  ready = new BehaviorSubject<boolean>(false);

  @Input() set searchResult(searchRes: RichSearchList) {
    if (searchRes) {
      this._searchResult = searchRes;
      this.facetService.consumeFacets(searchRes);
      this.ready.next(true);
    }
  }

  @Input() inProgress = true;

  _facetConfig: FiltersConfig;

  @Input() set facetsConfig(config: FiltersConfig) {
    this._facetConfig = config;
    this.facetService.facetsConfig = this._facetConfig;
  }

  public filtersInit = false;

  public searchInText: boolean;

  constructor(
    private appConfigService: AppConfigService,
    private htmlUtils: HtmlUtilsService,
    private listService: ListService,
    private facetService: FacetService
  ) {
    this.searchEvent = this.listService.urlChangeEvent;
  }

  ngOnInit() {
    this.searchEvent = this.listService.urlChangeEvent;
  }
}
